/*
Copyright 2024 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

export const fallbackLng = 'en'
export const languages = [fallbackLng, 'fr']
export const defaultNS = 'common'
export const headerName = 'x-i18next-current-language'

export function getOptions (lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    // React already escapes rendered output, so double-escaping here
    // only mangles interpolated values (e.g. dates with apostrophes).
    interpolation: { escapeValue: false }
  }
}